<template src='./pageTitle.pug' lang='pug'></template>

<script>
export default {
  name: 'PageTitle',

  props: [
    'title',
    'subTitle'
  ]
}
</script>

<style scoped>
.page-title-wrapper {
  font-family: 'Inter', sans-serif;
  margin-bottom: 15px;
  border-bottom: 1px solid #d0d0d0;
}

h1.primary-title {
  font-size: 2em;
  font-family: 'Inter', sans-serif;
font-weight: 700;
  color: #1d436a;
}

h4.subtitle {
  margin-top: 5px;
  color: #1d436a;
}

.button-wrapper {
  width: auto;
  float: right;
}
</style>



// WEBPACK FOOTER //
// PageTitle.vue?9b0a4f76